import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { parseCouponDate } from "config/utils";
import Loading from "components/Loading";
import CouponMessage from "components/CouponMessage";
import BtnCuponDisabled from "components/BtnCuponDisabled";
import LabelBonusCoupon from "components/LabelBonusCoupon";
import Counter from "components/Counter";
import "./style.scss";
import CouponSliderRoulette from "components/CouponSliderRoulette";



const CouponSliderItem = ({
    coupon = {},
    cart = {},
    eventHandle = null,
    controlTerms = null,
    materials=null,
    roulette=null,
    hasSession = true,
    disabled = false,
    hasCart = true,
    changeExpired = false,
    linesMsgMaior=null,
   
}) => {
    const [loading, setLoading] = useState(false);
    const [inCart, setInCart] = useState(false);
    const [cantCupDisLH, setcantCupDisLH] = useState([]); //cantidad disponible

    useEffect(() => {
        cantCupToArray(coupon.cantCupDisponiblesLH); //e
        linesMsg(coupon);
        if (cart?.state === "A") {
            setLoading(false);
            let item = cart.items?.find((itemCart) => itemCart.id == coupon.id);
            setInCart(!!item);
        }
    }, [cart]);

    const eventHandleCoupon = (event, action, coupon) => {
        event.preventDefault();
        if (eventHandle && !disabled) {
            setLoading(true);
            eventHandle(action, coupon);
        }
    };
    const showingLegal = (event, coupon) => {
        controlTerms && controlTerms(event, coupon);
        //controlTerms invoca a openTermiConditions de CouponSlider
 
    };
    const showingMateriales= (event, coupon) => {
        materials && materials(event, coupon);
        //controlTerms invoca a openTermiConditions de CouponSlider
    };

    //convert num a Array 15=> [0,0,1,5]
    const cantCupToArray = (cantCupLH) => {
        if (cantCupLH != null) {
            var myInt = cantCupLH.toString().padStart(4, 0); //string 0 to left
            let myFunc = (num) => Number(num); //function
            var intArr = Array.from(String(myInt), myFunc); //convert num to Array
            setcantCupDisLH(intArr);
        } else {
            setcantCupDisLH(null);
        }
    };
    const linesMsg =(coupon)=>{

        if(linesMsgMaior!=null){
        //count lines+limite+priceMaterial
       
            let lines=0;
            lines=lines+coupon.messages.message4.length;
            if(coupon.nivelMaterial==true){
                lines=lines+4;
            }
           
            
            return linesMsgMaior-lines;
            
        }
        return 0;

    }

    return (
        <div className={"slide"}>
            {coupon.id == "47952" ? (
                <CouponSliderRoulette 
                coupon={coupon}  
                linesMsgMaior={linesMsg(coupon)} 
                roulette={roulette}
                
                />
            ) : (
                <div
                    className={
                        (coupon.cuponBonus == true &&
                        coupon.cuponHabilitado == false
                            ? "coupon-bonus-disable"
                            : "") +
                        " coupon " +
                        (hasCart && inCart && "active")
                    }
                >
                    <div className="row">
                        {cantCupDisLH != null ? (
                            <Counter
                                cantCupDisponiblesLH={cantCupDisLH}
                                disable={true}
                                cantNumber={coupon.cantCupDisponiblesLH}
                            />
                        ) : (
                            <br></br>
                        )}
                        <LabelBonusCoupon
                            couponBonus={coupon.cuponBonus}
                            couponHabilitado={coupon.cuponHabilitado}
                        />
                    </div>
                    <div className="row">
                        <div className="col-5">
                            <p
                                className={
                                    coupon.cuponBonus == true &&
                                    coupon.cuponHabilitado == false
                                        ? "image image-bonus"
                                        : "image"
                                }
                            >
                                <img
                                    src={coupon.image}
                                    alt={coupon.nameCoupon}
                                />
                            </p>
                        </div>
                        <div className="col-7">
                            <div className="container p-0">
                                <div className="row">
                                    <div className="col-12 info">
                                        <CouponMessage
                                            data={coupon}
                                            inCart={inCart}
                                            linesMsgMaior={linesMsg(coupon)}
                                        />
                                    </div>
                                </div>
                            </div>
                            {eventHandle && (
                                <div className="buttons">
                                    {coupon.cuponBonus == true &&
                                    coupon.cuponHabilitado == false ? (
                                        <BtnCuponDisabled />
                                    ) : (
                                        <a
                                            href="#"
                                            className={
                                                "btn no-hover" +
                                                (disabled && !loading && !inCart
                                                    ? " btn-disabled"
                                                    : "")
                                            }
                                            onClick={(event) => {
                                                eventHandleCoupon(
                                                    event,
                                                    inCart
                                                        ? "remove_item"
                                                        : "add_item",
                                                    coupon
                                                );
                                            }}
                                        >
                                            {loading ? (
                                                <Loading type=" size-xxs" />
                                            ) : (
                                                <>
                                                    <span className="added">
                                                        Cupón agregado
                                                    </span>
                                                    <span className="add">
                                                        Agregar cupón
                                                    </span>
                                                </>
                                            )}
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="col-12">
                            <p className="valid">
                                Vence{" "}
                                {parseCouponDate(
                                    coupon.vencimiento,
                                    changeExpired
                                )}
                            </p>
                            {hasSession && (
                                <>
                                    <p className="legal">
                                        <a
                                            href="#"
                                            onClick={(event) =>
                                                showingLegal(event, coupon)
                                            }
                                        >
                                            Ver legal
                                        </a>
                                    </p>
                                    {hasCart != false && (
                                        <p className="productos">
                                            <a
                                                href="#"
                                                onClick={(event) =>
                                                    showingMateriales(
                                                        event,
                                                        coupon
                                                    )
                                                }
                                            >
                                                productos
                                            </a>
                                        </p>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

CouponSliderItem.propTypes = {
    coupon: PropTypes.object,
    cart: PropTypes.object,
    eventHandle: PropTypes.func,
    controlTerms: PropTypes.func,
    materials:PropTypes.func,
    roulette:PropTypes.func,
    hasSession: PropTypes.bool,
    disabled: PropTypes.bool,
    hasCart: PropTypes.bool,
    changeExpired: PropTypes.bool,
    cantCupDispoLH: PropTypes.number,
    linesMsgMaior:PropTypes.number,
    
    
};

export default CouponSliderItem;
